import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MenuItem } from '@layout/models/menu-item.model';
import { SessionService } from '@core/services/session.service';
import { Subscription } from 'rxjs';
import { MenuService } from '@layout/services/menu.service';
import { MenuPosition, MenuPositionService } from '@layout/services/menu-position.service';
import { SidebarService } from '@layout/services/sidebar.service';
import { MenuComponent } from './menu.component';
import { NavbarComponent } from './navbar.component';
import { SidebarComponent } from './sidebar.component';
import { SectionComponent } from './section.component';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'va-layout',
    template: `
    <div class="layout-wrapper">
      <va-menu></va-menu>
      @if (menuPosition === 'top') {
        <div class="layout-navbar">
          <va-navbar [userInfo]="userInfo" [menuItems]="menuItems"></va-navbar>
        </div>
      } @else {
        <div class="layout-sidebar" [class.open]="!!menuItem" [class.close]="!menuItem">
          <va-sidebar
            [userInfo]="userInfo"
            [menuItems]="menuItems"
            (menuOnChange)="onClickMenu($event)"
          ></va-sidebar>
          <va-section [menuItem]="menuItem"></va-section>
        </div>
      }
      <div class="layout-content" [class.top-menu]="menuPosition === 'top'" [class.open]="menuPosition === 'left' && !!menuItem" [class.close]="menuPosition === 'left' && !menuItem">
        <div class="layout-content-inner">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  `,
    standalone: true,
    imports: [
        MenuComponent,
        NavbarComponent,
        SidebarComponent,
        SectionComponent,
        RouterOutlet,
    ],
})
export class LayoutComponent implements OnInit, OnDestroy {
  private menuService = inject(MenuService);
  private sessionService = inject(SessionService);
  private menuPositionService = inject(MenuPositionService);
  private sidebarService = inject(SidebarService);

  subscription: Subscription;
  private menuPositionSubscription: Subscription;
  private sidebarStateSubscription: Subscription;
  menuItems: MenuItem[];
  menuItem: MenuItem;
  menuPosition: MenuPosition = 'top';
  userInfo: any;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  ngOnInit(): void {
    this.getMenuItems();
    this.getUserDetails();

    this.menuPositionSubscription = this.menuPositionService.getMenuPosition().subscribe((menuPosition) => {
      this.menuPosition = menuPosition;
    });

    this.sidebarStateSubscription = this.sidebarService.getState().subscribe((state) => {
      if (!state) {
        this.menuItem = null;
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.menuPositionSubscription.unsubscribe();
    this.sidebarStateSubscription.unsubscribe();
  }

  onClickMenu(menuItem: MenuItem): void {
    if (menuItem.Childs.length === 0) {
      this.menuItem = null;
      this.sidebarService.setState(false);
    } else {
      this.menuItem = menuItem;
      this.sidebarService.setState(true);
    }
  }

  private getUserDetails(): void {
    this.userInfo = this.sessionService.getItem('currentUser');
  }

  private getMenuItems(): void {
    this.subscription = this.menuService.getMenu().subscribe((menuItems) => {
      this.menuItems = menuItems;
    });
  }
}
